import { get, set } from 'lodash';

export const FormRadio = {
  transclude: true,

  bindings: {
    form: '<',
    model: '<',
    key: '@',
    value: '@',
    onUpdate: '&',
  },

  template: `
    <label>
      <input
        type="radio"
        name="{{ $ctrl.key }}"
        value="{{ $ctrl.value }}"
        ng-model="$ctrl.form.data[$ctrl.key]"
        ng-click="$ctrl.onUpdate({
          key: $ctrl.key,
          value: $ctrl.value,
        })"/>
      <span class="pl-1" ng-transclude></span>
    </label>`,

  controller() {
    return {
      $onChanges(changes) {
        const newValue = get(changes, 'model.currentValue', '').toString();
        const oldValue = get(this.form.data, this.key);

        if (newValue.length && newValue !== oldValue) {
          set(this.form, ['data', this.key], newValue);
        }
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/FormElements/FormRadio.js